import { render } from "./MyWorkflow.vue?vue&type=template&id=b463d92c"
import script from "./MyWorkflow.vue?vue&type=script&lang=js"
export * from "./MyWorkflow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__